import { setHeader } from "@/util/set-header";
import { Icon, Toast } from "antd-mobile";
import React from "react";
import './change-area.less'
import { withRouter } from "react-router";
import CitySelect from 'react-city-select';
import { StoreCityListApi } from "@/api/sany";
@(withRouter as any)
export default class ChangeArea extends React.Component<any, any> {
  state = {
    posCityName:'上海市',
    cityName: sessionStorage.getItem('sanyCityName'),
    cityId: sessionStorage.getItem('sanyCityId'),
    // 结构化城市列表数据
    // citysData: indexCitys,
    citysData: {
      pos:[
        {id:'321',name:'上海'}
      ]
    },
    // 对某项数据定制化配置
    config: {
      pos: {
        icon: '../../../../public/assets/img/icon.png', // 游标图标
        title: '定位城市',
      },
    }
  };
  constructor(prop: any) {
    super(prop);
    this.leftClick = this.leftClick.bind(this)
    this.goHomePage = this.goHomePage.bind(this)
    this.rightBtn = this.rightBtn.bind(this)
  }
  componentDidMount() {
    setHeader({ title: '选择区域', leftToHome: this.goHomePage, leftClick: this.leftClick, right: this.rightBtn() })
    this.getMap()
  }
  getMap() {
    const _this=this;
    var BMap = window.BMap;
    var geoc = new BMap.Geocoder();
    var geolocation = new BMap.Geolocation();
     geolocation.getCurrentPosition(function (r: any) {
        geoc.getLocation(r.point, function (rs: any) {
            var addComp = rs.addressComponents;
            let cityName = addComp.city;
            // console.log(cityName, 'cityName')
            _this.setState({
              posCityName:cityName,  //城市名
            }, async ()=>{
              await _this.getCityList()
            })
            // console.log(_this.state.posCityName, 'posCityName')
        });
    });
  }
  getCityList(){
    StoreCityListApi({}).then((res:any)=>{
     if(res.data.code === 'SUCCESS') {
      const arr = res.data.data
      let changeId = ''
      arr.forEach((v:any) => {
        if (this.state.posCityName.indexOf(v.name)!==-1) {
          changeId = v.id
        }
      })
      const posArr = {
        pos:[
          {id:changeId,name:this.state.posCityName}
        ]
      }
      this.setState({
        citysData: Object.assign(posArr,{'城市':arr}),
      })
     } else {
      Toast.info(res.data.msg)
     }
    })
  }
//  async componentWillReceiveProps() {
//     const _this=this;
//     var BMap = window.BMap;
//     var geoc = new BMap.Geocoder();
//     var geolocation = new BMap.Geolocation();
//     geolocation.getCurrentPosition(function (r: any) {
//         geoc.getLocation(r.point, function (rs: any) {
//             console.log(rs, '777777777777')   //具体信息可以打印出来看一下，根据需求取值     经纬度，城市，街道等等
//             var addComp = rs.addressComponents;
//             let cityName = addComp.city;
//             _this.setState({
//               posCityName:cityName,  //城市名
//             })
//         });
//     });
//   }
  leftClick() {
    this.props.history.push({
      pathname: '/sany/change-store',
      // state: {cityId: this.state.cityId, cityName: this.state.cityName}
    })
  }

  goHomePage() {
    this.props.history.replace('/sany/dorm-list')
  }

  rightBtn() {
    return (
      <div style={{ display: 'flex', fontSize: '12px' }}>
        <div style={{ marginTop: '5px' }}>{this.state.cityName}</div>
        <div><Icon type="down" /></div>
      </div>
    )
  }

  // 选中城市回调
  async handleSelectCity(val: any) {
    await this.setState({
      cityName: val.name,
      cityId: val.id,
    })
    await setHeader({
      title: '选择区域', leftToHome: this.goHomePage, leftClick: this.leftClick, right: this.rightBtn()
    })
    // 传递给门店类别页面用的
    this.props.history.push({
      pathname: '/sany/change-store',
    })
    // 存值本页面用
    sessionStorage.setItem('sanyCityName', val.name)
    sessionStorage.setItem('sanyCityId', val.id)
  }
  render() {
    return (
      <div style={{ background: '#fff' }}>
        <div style={{ position: 'absolute',top: '69px',right: '5px'}} onClick={() =>  this.getMap()}>
          <img src='../../../../public/assets/img/icon.png' style={{marginTop:'6px'}}  />
        </div>
        <CitySelect
          // 传入数据
          data={this.state.citysData}
          // 传入配置
          config={this.state.config}
          // 传入回调
          onSelectItem={this.handleSelectCity.bind(this)}>
        </CitySelect>
      </div>
    )
  }
}